<script setup lang="ts">
import { tryUseDialogLayer } from "../../composables/Dialog/useDialogLayer";
import VCloseButton from "../CloseButton/VCloseButton.vue";

const { placement = "absolute" } = defineProps<{
  placement?: "absolute" | "inline"
}>();

const emit = defineEmits<{
  click: [event: MouseEvent]
}>();

// The host close sits at a 12px inset; a header bar moves it onto the body gutter (see Dialog.scss).
const layer = tryUseDialogLayer();

function handleClick(event: MouseEvent) {
  event.stopPropagation();
  emit("click", event);
  void layer?.close();
}
</script>

<template>
  <VCloseButton
    class="close-icon"
    :class="placement === 'absolute' ? 'absolute top-3 right-3 z-10' : undefined"
    @click="handleClick"
    @mousedown.stop
  />
</template>
